import {Link} from 'react-router-dom';
import serviceBg from '../../assets/img/service1.jpg';

function Services() {
  return (
    <>
      <div className="ltn__about-us-area section-bg-1 pb-115 mt-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 align-self-center">
              <div className="about-us-img-wrap ltn__img-shape-left  about-img-left">
                <img src={serviceBg} alt="client" />
              </div>
            </div>
            <div className="col-lg-7 align-self-center">
              <div className="about-us-info-wrap">
                <div className="section-title-area ltn__section-title-2--- mb-20">
                  <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                    About Us
                  </h6>
                  <h1 className="section-title">
                    We provide personalised care
                    <br /> for adults and children
                  </h1>
                </div>
                <div className="section-title-area ltn__section-title-2--- mb-20">
                  <p>
                    We are a vibrant, flexible, and responsive person-centred
                    complex health and home care service with headquarters in
                    the scenic town of Evesham, Wychavon district of
                    Worcestershire, in the West Midlands region of England. As a
                    trusted provider of complex home care, we operate through
                    local operational hubs across the UK. We work in partnership
                    with Integrated Care Boards (ICBs), Case Managers, Local
                    Authorities as well as Private Clients and those arranging
                    care funded through their Personal Health Budget (PHB).
                  </p>
                </div>
                <div className="about-us-info-wrap-inner about-us-info-devide---">
                  <p>
                    We provide a 24-hour service to adults, young people and
                    children who want to continue living in the community in the
                    comfort of their own homes with physical disabilities,
                    learning disabilities, mental health issues, with sensory
                    loss, including those with dual sensory impairment and
                    complex health care needs such as PEG/NG feeds, stoma care,
                    tracheostomy care, acquired brain injury and spinal injury
                    etc.
                  </p>
                  <p>
                    Our dedicated, skilled and experienced health and social
                    care teams are committed to ensuring that we consistently
                    deliver a high quality, person-centred service to
                    individuals with long-term or life-limiting conditions.
                  </p>
                  <div className="btn-wrapper animated">
                    <Link
                      to="/about-quality"
                      className="theme-btn-1 btn btn-effect-1 text-uppercase"
                    >
                      Read more
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ltn__service-area  pt-115 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center">
                <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                  Why us?
                </h6>
                <h1 className="section-title">Why quality healthcare?</h1>
              </div>
            </div>
          </div>
          <div className="row  justify-content-center">
            <div className="col-lg-4 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
                <div className="ltn__feature-info">
                  <h3>
                    <Link to="/excellence">Excellence</Link>
                  </h3>
                  <p>
                    We believe that quality and clinical excellence are
                    essential to providing the very best care.
                  </p>
                </div>
                <div className="btn-wrapper animated">
                  <Link
                    to="/excellence"
                    className="theme-btn-1 btn btn-effect-1 text-uppercase"
                  >
                    Learn more
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
                <div className="ltn__feature-info">
                  <h3>
                    <Link to="/our-values">Our values - The 6 Cs</Link>
                  </h3>
                  <p>
                    The care we deliver to all our clients is rooted in the 6
                    Cs.
                  </p>
                </div>
                <div className="ltn__feature-icon">
                  <div className="btn-wrapper animated">
                    <Link
                      to="/our-values"
                      className="theme-btn-1 btn btn-effect-1 text-uppercase"
                    >
                      Learn more
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
                <div className="ltn__feature-info">
                  <h3>
                    <Link to="/team">Our people</Link>
                  </h3>
                  <p>
                    Connecting skills, expertise and knowledge to offer the
                    highest-quality care services.
                  </p>
                </div>
                <div className="btn-wrapper animated">
                  <Link
                    to="/team"
                    className="theme-btn-1 btn btn-effect-1 text-uppercase"
                  >
                    Learn more
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Services;
